
export interface MyLog {
  id?: string,
  created: any,
  user: LogUserInfo,
  type: LogType,
  event: any,
  message: string
  hostId: string,
  process?: any,
  requestId?: string
}

export interface LogUserInfo{
  // ebben a templateben undefined!!
  // id?: string | number,
  email? : string
}

export interface LogProcess {
  name: string,
  created: any,
  requestId?: string,
}


export enum LogType {
  error = 'error',
  timeLog = 'timeLog',
  reportLog = 'reportLog'
}

export interface LogReport{
  logId?: string,
  created?: any,
  status?: string,
  processName?: string,
  processType?: string,
  createNew?: boolean,
  data?: any,
  successFinished?: boolean
}

